import React from 'react';
import headerStyles from './index.scss';

/**
 * CustomHeader Component
 * @param title
 * @returns {*}
 * @constructor
 */
export const CustomHeader = ({ title, style }) => {
  return <div className={style || headerStyles.headerClass}>{title}</div>;
};

export const CustomHeaderMandatory = ({ title, style }) => {
  return (
    <div>
      <span>{title} </span>
      <span style={{ color: 'red' }}>*</span>
    </div>
  );
};

/**
 * CustomHeaderV2
 * @param title
 * @returns {*}
 * @constructor
 */
export const CustomHeaderV2 = ({ title, style }) => {
  return (
    <div style={style} className={headerStyles.headerClassV2}>
      {title}
    </div>
  );
};
